import { GridValidRowModel } from "@mui/x-data-grid";

export const preventAddingDuplocateRowForContact = (
  rows: any[] | readonly GridValidRowModel[]
) => {
  if (!rows || rows.length === 0) return true;
  const obj = rows?.[0];
  if (!obj) return false;

  // return false ONLY if all values are "" or undefined
  const allEmpty = Object.values(obj).every(
    (value) => value === "" || value === undefined
  );

  return !allEmpty;
};
